type Property = "flocktank" | "flockworker" | "flocklist";

const DEFAULT_URLS: Record<Property, string> = {
  flocktank: "https://flocktank.econchangers.com",
  flockworker: "https://flockworker.econchangers.com",
  flocklist: "https://flocklist.econchangers.com",
};

const ENV_VAR_MAP: Record<Property, string> = {
  flocktank: "FLOCKTANK_URL",
  flockworker: "FLOCKWORKER_URL",
  flocklist: "FLOCKLIST_URL",
};

export function isStaging(): boolean {
  if (process.env.NEXT_PUBLIC_APP_ENV === "staging") return true;

  const appUrl = process.env.NEXT_PUBLIC_APP_URL || "";
  if (appUrl.includes("staging")) return true;

  if (process.env.VERCEL_ENV === "preview") return true;

  if (process.env.NODE_ENV === "development") return true;

  return false;
}

export function getPropertyUrl(property: Property): string {
  return process.env[ENV_VAR_MAP[property]] || DEFAULT_URLS[property];
}

export function getFlocktankUrl(): string {
  return getPropertyUrl("flocktank");
}

export function getFlockworkerUrl(): string {
  return getPropertyUrl("flockworker");
}

export function getFlocklistUrl(): string {
  return getPropertyUrl("flocklist");
}
